import { ConfirmationModal, type ConfirmationModalProps, Text } from '@shared/components';

type QSetPublishConfirmationModalProps = Pick<
  ConfirmationModalProps,
  'onClose' | 'onAccept' | 'onDiscard' | 'open' | 'loading'
>;

export default function QSetPublishConfirmationModal(
  props: Readonly<QSetPublishConfirmationModalProps>,
) {
  const { onClose, onAccept, onDiscard, open: isOpen, loading: isLoading } = props;

  return (
    <ConfirmationModal
      open={isOpen}
      title='Publish QSet?'
      content={
        <Text color='text.secondary'>
          เมื่อทำการ Publish แล้ว{' '}
          <strong>ชุดข้อสอบจะพร้อมใช้งานสำหรับการจัดสอบ และจะไม่สามารถแก้ไขเนื้อหาได้อีก</strong>{' '}
          กรุณาตรวจสอบความถูกต้องให้เรียบร้อยก่อนดำเนินการต่อ
        </Text>
      }
      onClose={onClose}
      onAccept={onAccept}
      onDiscard={onDiscard}
      acceptText='Publish'
      loading={isLoading}
    />
  );
}
